import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PoModule } from '@po-ui/ng-components';
import { SimplesNacionalComponent } from './simples-nacional.component';

@NgModule({
  declarations: [SimplesNacionalComponent],
  exports: [SimplesNacionalComponent],
  imports: [CommonModule, PoModule]
})
export class SimplesNacionalModule {}
